
import Component from 'vue-class-component';
import Vue from 'vue';
import { Prop } from 'vue-property-decorator';
import StatusBadge from '@/core/components/StatusBadge.vue';
import SummaryCard from '@/core/components/SummaryCard.vue';
import PaymentAmountWidget from '@/core/components/PaymentAmountWidget.vue';
import { LoanDetails } from '@/loan/types/loan-details';
import { UtilHelper } from '@/util/helper';
import { StatusBadgeStatus } from '@/core/enums/status-badge-status';
import { MONTH_MAP } from '@/util/constants/month-map';

const TEST_ID = 'Kloans-LoanOverdueCard';

@Component({
	components: {
		StatusBadge,
		SummaryCard,
		PaymentAmountWidget,
	},
})
export default class LoanOverdueCard extends Vue {
	public TEST_ID = TEST_ID;

	public formatDollar = UtilHelper.formatDollar;

	@Prop()
	public loanDetails!: LoanDetails;

	@Prop()
	public loanId!: string;

	public bagdeStatus = StatusBadgeStatus.ERROR;

	get daysUntilDue(): number {
		const dueDate = new Date(this.loanDetails?.general?.paymentDueDate);
		const today = new Date();

		return UtilHelper.getTotalDaysBetweenDates(
			today,
			dueDate,
		);
	}

	get daysOverdue(): number {
		return this.loanDetails?.general?.delinquentDays ?? 0;
	}

	get dueDate(): string {
		const date = new Date(this.loanDetails?.general?.paymentDueDate);
		const dayOfMonth = date.getDate();
		const monthNum = date.getMonth() + 1;
		const month = MONTH_MAP.get(monthNum);

		return `${month} ${dayOfMonth}`;
	}

	get overdueAmount(): string {
		return this.loanDetails?.general?.installmentPastDue ?? String(0);
	}

	get paymentDueAmount(): string {
		return this.loanDetails?.general?.paymentDueAmount ?? String(0);
	}

	get remaingAmountDue(): string {
		return this.loanDetails?.general?.remainingInstallmentDue ?? String(0);
	}
}

